
import './App.css';
import Inicio from './Componentes/Inicio';
import OutputVisualization from './Componentes/OutputVisualization';
import { useEffect } from 'react';

function App() {

  

  return (
    <div className="bg-gray-700 w-full min-h-screen flex flex-col">
      <Inicio/>
    </div>
  );
}

export default App;
